import Switch from '@material-ui/core/Switch';
import * as React from 'react';

const SwitchWrapper = ({ input: { checked, name, onChange, ...restInput }, meta, ...rest }) => (
	<Switch {...rest} name={name} inputProps={restInput} onChange={onChange} checked={checked} />
);

export default SwitchWrapper;
